import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TransitionedBlock from "../HelperComponents/TransitionedBlock/TransitionedBlock";
import Pagination from '../HelperComponents/Pagination/Pagination';
import AddIcon from '../../assets/image/add.png';
import PrintIcon from '../../assets/image/print.png';
import PrintResidueDocument from './PrintResidueDocument/PrintResidueDocument';

import { getAllResidues, getResidueById } from "../../actions/disposalBalancesActions";

import './DisposalBalances.scss';
import moment from "moment/moment";

class DisposalBalances extends Component {

    state = {
        activePage: 1,
        printData: null,
        currentCompany: null,
        currentDate: null
    };

    componentDidMount = () => {
        this.doRequest();
    };

    doRequest = () => {
        const { getAllResidues } = this.props;
        const { activePage } = this.state;

        const params = {
            page_size: 25,
            page: activePage
        };

        getAllResidues(params).then(res => {
            if (res.payload) {
                this.setState({ loading: false })
            }
        });
    };

    changePage = (pageNumber) => {
        this.setState({ activePage: pageNumber.selected + 1 });
        setTimeout(() => {
            this.doRequest();
        }, 0);
    };

    handlePrint = (residueId, company, date) => {
        const { getResidueById } = this.props;
        this.setState({ 
            currentCompany: company,
            currentDate: date
        });
        getResidueById(residueId).then(res => {
            if (res.payload && res.payload.data) {
                this.setState({ printData: res.payload.data });
                setTimeout(() => {
                    const button = document.getElementById('print_button_residue');
                    if (button) button.click();
                }, 100);
            }
        });
    };

    render(){
        const { disposal_balances:{ all_residues }} = this.props;
        const { activePage, printData, currentCompany, currentDate } = this.state;
        if (!all_residues.results) return null;

        return (
            <TransitionedBlock>
                <div className="disposal_balances container">
                    <div className="flex-center-btw title-block-page">
                        <div className="title-page">
                            <h1>Выдача остатков</h1>
                        </div>
                        <div className="add_button">
                            <Button
                                component={Link}
                                to="new-issue"
                                classes={{
                                    root: 'add_btn'
                                }}
                            >
                                Добавить
                                <img src={AddIcon} alt="edit icon"/>
                            </Button>
                        </div>
                    </div>
                    <div className="page_block">
                        <div className="disposal_balances_table">
                            <div className="table_container transactions_columns">
                                <div className="table_header">
                                    <div className="table_row">
                                        <div className="row_item">Дата/время</div>
                                        <div className="row_item">Кому выдали</div>
                                        <div className="row_item">К-во выданных товаров</div>
                                        <div className="row_item">Комментарий</div>
                                        <div className="row_item">Номер выдачи заказа</div>
                                        <div className="row_item">Печать</div>
                                    </div>
                                </div>
                                <div className="table_body">
                                    {all_residues.results.map((item, idItem) => (
                                        <div className="table_row" key={idItem}>
                                            <div className="row_item">{moment(item.date).format('DD.MM.YYYY HH:mm')}</div>
                                            <div className="row_item">{item.company}</div>
                                            <div className="row_item">{item.product_count}</div>
                                            <div className="row_item">{item.comment}</div>
                                            <div className="row_item">{item.document_number}</div>
                                            <div className="row_item">
                                                <button 
                                                    className="print_btn_small" 
                                                    onClick={() => this.handlePrint(item.id, item.company, item.date)}
                                                >
                                                    <img src={PrintIcon} alt="print" />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {all_residues.count && all_residues.count > 25 ?
                                <div>
                                    <Pagination
                                        active={activePage}
                                        pageItemsCount={25}
                                        pageTotalCount={all_residues.count}
                                        onChange={this.changePage}
                                    />
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <PrintResidueDocument 
                        printData={printData}
                        company={currentCompany}
                        date={currentDate}
                    />
                </div>
            </TransitionedBlock>
        );
    }
}

const mapStateToProps = ({disposal_balances}) => ({
    disposal_balances
});

const mapDispatchToProps = {
    getAllResidues,
    getResidueById
};

export default connect(mapStateToProps, mapDispatchToProps)(DisposalBalances);